import React from 'react'

import 'react-circular-progressbar/dist/styles.css'
import { revelarImportarDescricao } from '../../../redux/actions/index'

import ModalImportarArquivo from './importarArquivo'

export default function ModalImportarDescricao(props) {
  const aviso =
    'Ao preencher o template, para manter um campo inalterado, deixe o campo em branco. Para deixar um campo vazio, digite a tag: <apagar/>'

  return (
    <ModalImportarArquivo
      aviso={aviso}
      importarDescricao
      revelarModal={revelarImportarDescricao}
      impedirMultiplosArquivos
      {...props}
    />
  )
}
